import request from './request';
/**
 *  获取所有车品牌
 */
export function getvehicleBrands() {
    return request('/booking-order/vehicle/brands', {
        method: 'GET',
    });
}

/**
 * 获取品牌下所有车系
 */
export function getBrandSerials(params) {
    return request(`/booking-order/vehicle/${params.brandId}/serials`, {
        method: 'GET',
    });
}
/**
 * 获取车系下所有车型
 */
export function getSerialTypes(params) {
    return request(`/booking-order/vehicle/${params.serial}/types`, {
        method: 'GET',
    });
}

/**
 * 获取预约设置
 */
export function getAppointmentSetting() {
    return request('/booking-config/workforce', {
        method: 'GET',
    });
}

/**
 * 修改预约设置
 */
export function setAppointmentSetting(params) {
    return request('/booking-config/workforce', {
        method: 'POST',
        params,
    });
}

/**
 * 获取预约服务时间段
 */
export function getServiceScope() {
    return request('/booking-config/service-scope', {
        method: 'GET',
    });
}

/**
 * 修改预约服务时间段
 */
export function setServiceScope(params) {
    return request('/booking-config/service-scope', {
        method: 'PUT',
        params,
    });
}

/**
 * 获取排班表
 */
export function getAppointmentBoard(params) {
    return request('/booking-data/calendar', {
        method: 'GET',
        params,
    });
}
/**
 * 获取排班表详情
 */
export function getBoardDetail(params) {
    return request('/booking-data/calendar/detail', {
        method: 'GET',
        params,
    });
}

/**
 * 获取预约看板
 */
export function getBoardview(params) {
    return request('booking-data/board-view', {
        method: 'POST',
        params,
    });
}
/**
 * 获取当前可预约时段
 */
export function getAvailableTime(params) {
    return request('/booking-config/time-quantum', {
        method: 'GET',
        params,
    });
}
/**
 * 获取预约列表
 */
export function getAppointmengList(params) {
    return request('/booking-order/list', {
        method: 'POST',
        params,
    });
}
/**
 * 获取联系人相关信息
 */
export function getCustomer(params) {
    return request('/booking-order/customer', {
        method: 'GET',
        params,
    });
}
/**
 * 新增预约
 */
export function addAppointment(params) {
    return request('/booking-order', {
        method: 'POST',
        params,
    });
}

/**
 * 订单详情
 */
export function getOrderDetail(id) {
    return request(`/booking-order/${id}`, {
        method: 'GET',
    });
}

/**
 * 跟单备注列表查询
 */
export function getRemarkList(id, params) {
    return request(`/booking-order/${id}/remark`, {
        method: 'GET',
        params,
    });
}
/**
 * 跟单备注提交
 */
export function addRemark(id, params) {
    return request(`/booking-order/${id}/remark`, {
        method: 'POST',
        params,
    });
}
/**
 * 订单受理/确认到店/取消/关闭
 */
export function changeOrderState(params) {
    return request('/booking-order/state', {
        method: 'PUT',
        params,
    });
}
/**
 * 变更预约时间
 */
export function changeOrderTime(params) {
    return request('/booking-order/date', {
        method: 'PUT',
        params,
    });
}
/**
 * 申述数据查询
 */
export function getComplaintData(id) {
    return request(`/booking-order/${id}/appeal`, {
        method: 'GET',
    });
}
/**
 * 发起申述
 */
export function setComplaint(params) {
    return request('/booking-order/appeal', {
        method: 'POST',
        params,
    });
}
/**
 * 到店数据查询
 */
export function getArriveData(id) {
    return request(`/booking-order/${id}/maintenance`, {
        method: 'GET',
    });
}
/**
 * 补全到店数据
 */
export function setSupply(params) {
    return request('/booking-order/maintenance', {
        method: 'POST',
        params,
    });
}
/**
 * 详情操作记录
 */
export function getHistoryList(id, params) {
    return request(`/booking-order/${id}/record`, {
        method: 'GET',
        params,
    });
}
/**
 * 变更维保信息
 */
export function changeMaintenance(params) {
    return request('/booking-order/maintenance/state', {
        method: 'PUT',
        params,
    });
}
/**
 * 查询是否可申述
 */
export function getAppealStatus(id) {
    return request(`/booking-order/${id}/is-appeal`, {
        method: 'GET',
    });
}
/**
 * 到店审核数据查询
 */
export function getArriveAuditData(id) {
    return request(`/booking-order/${id}/arrive-audit-data`, {
        method: 'GET',
    });
}

// 获取本店服务车辆品牌树
export function getBrandTree() {
    return request('/booking-order/brandTree', {
        method: 'GET',
    });
}

/**
 * 编辑到店时间
 */
export function editArriveTime(id, params) {
    return request(`/booking-order/${id}/arrive-time`, {
        method: 'PATCH',
        params,
    });
}

/**
 * 编辑车牌号码
 */
export function editPlateNumber(id, params) {
    return request(`/booking-order/${id}/plate-number`, {
        method: 'PATCH',
        params,
    });
}

/**
 * 编辑到店详情
 */
export function editArriveInfo(id, params) {
    return request(`/booking-order/${id}/arrive-info`, {
        method: 'PATCH',
        params,
    });
}

/**
 * 编辑车型
 */
export function editvehicle(id, params) {
    return request(`/booking-order/${id}/vehicle`, {
        method: 'PATCH',
        params,
    });
}
/**
 * 获取预约订单相关枚举
 */
export function getBookingOrderEnum(params) {
    return request('/booking-order/enum', {
        method: 'GET',
        params,
    });
}
/**
 * 上门取车详情修改
 */
export function updatePickup(params) {
    return request('/booking-order/pick-up/detail', {
        method: 'PUT',
        params,
    });
}
